import { getCookie } from "@/services/utils";

export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}


// icons are from https://fonts.google.com/icons?selected=Material+Symbols+Outlined:content_paste_search:FILL@0;wght@400;GRAD@0;opsz@24&icon.size=24&icon.color=%231f1f1f
const nav = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'area_chart',
      },
    },
    {
      name: 'cdn-scanner',
      displayName: 'CDN Scanner',
      meta: {
        icon: 'cloud',
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}

if (['OWNER', 'ADMIN', 'DASHBOARD_PLUS_USER'].indexOf(getCookie('bragg_lobby_user_role') as string) > -1) {
  nav.routes.unshift({
    name: 'clientLogs',
    displayName: 'menu.clientLogs',
    meta: {
      icon: 'content_paste_search',
    },
  },)
}

if (['OWNER', 'ADMIN'].indexOf(getCookie('bragg_lobby_user_role') as string) > -1) {
  nav.routes.unshift({
    name: 'users',
    displayName: 'menu.users',
    meta: {
      icon: 'group',
    },
  })
  /*nav.routes.unshift({
    name: 'cdn-scanner',
    displayName: 'CDN Scanner',
    meta: {
      icon: 'cloud',
    },
  })*/
  nav.routes.unshift({
    name: 'jira-admin',
    displayName: 'JIRA Admin',
    meta: {
      icon: 'bug_report',
    },
  })
}

if (getCookie('bragg_lobby_user_role') === 'OWNER') {
  nav.routes.unshift({
    name: 'sessions',
    displayName: 'Sessions',
    meta: {
      icon: 'group',
    },
  })
}

export default nav
